<template>
  <div>
    <div class="row">
      <div class="form-group col-sm-6">
        <label for="schedule-date" v-translate>Date</label>
        <div class="input-group">
          <b-form-select id="schedule-date" v-model="slotDate" class="lg-3" @change="emitChange" :options="scheduleDays">
          </b-form-select>
        </div>
      </div>

      <div class="form-group col-sm-6">
        <label for="schedule-slot" v-translate translate-context="after N hour">After</label>
        <div class="input-group">
          <b-form-select id="schedule-slot" v-model="slotSlot" class="lg-3" @change="emitChange" :options="scheduleSlots">
          </b-form-select>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ScheduleDaySlot',
  props: {
    noWeekends: {
      type: Boolean,
      default: false
    },
    days: {
      type: Number,
      default: 4
    },
    firstSlotHour: {
      type: Number,
      default: 8
    },
    firstSlotMinute: {
      type: Number,
      default: 0
    },
    lastSlotHour: {
      type: Number,
      default: 18
    },
    lastSlotMinute: {
      type: Number,
      default: 0
    },
    slotLength: { // In minutes
      type: Number,
      default: 30
    }
  },
  data() {
    return {
      scheduleDays: [],
      scheduleSlots: [],
      slotDate: null,
      slotSlot: null,
      interval: null
    }
  },
  mounted() {
    this.emitChange()
    this.interval = setInterval(function () {
      this.emitChange()
    }.bind(this), 500)
  },
  beforeDestroy() {
    clearInterval(this.interval)
  },
  methods: {
    firstSlot(date) {
      return this.moment(date).set({ hour: this.firstSlotHour, minute: this.firstSlotMinute, second: 0, millisecond: 0 })
    },
    lastSlot(date) {
      return this.moment(date).set({ hour: this.lastSlotHour, minute: this.lastSlotMinute, second: 0, millisecond: 0 })
    },
    scheduledDateDays() {
      this.scheduleDays = []
      const now = this.moment()
      let day = this.moment()

      // Today
      if ((!this.noWeekends || (now.weekday() !== 5 && now.weekday() !== 6)) && now <= this.lastSlot(now)) {
        this.scheduleDays.push({
          moment: now,
          text: this.moment(now).local().format('ddd D MMMM'),
          value: this.moment(now).local().format('YYYY-MM-DD')
        })
      }
      // Next days
      for (let i = 0; i + 1 <= ((!this.noWeekends || (now.weekday() !== 5 && now.weekday() !== 6)) && now <= this.lastSlot(now) ? this.days - 1 : this.days); i++) {
        day = day.add(1, 'days')
        if (!this.noWeekends || (this.moment(day).weekday() !== 5 && this.moment(day).weekday() !== 6)) {
          this.scheduleDays.push({
            moment: day,
            text: this.moment(day).local().format('ddd D MMMM'),
            value: this.moment(day).local().format('YYYY-MM-DD')
          })
        } else {
          i--
        }
      }
      this.slotDate = this.slotDate || this.scheduleDays[0].value
      this.scheduledDateDaySlots()
    },
    scheduledDateDaySlots() {
      this.scheduleSlots = []
      const date = this.moment(this.moment(this.slotDate).set({ hour: 0, minute: 0, second: 0, millisecond: 0 })).local()
      let ended = false

      do {
        date.add(this.slotLength, 'minutes')
        if (date >= this.moment().local() && date >= this.firstSlot(date) && date <= this.lastSlot(date)) {
          this.scheduleSlots.push({
            text: date.local().format('LT'),
            value: date.local().format('HH:mm:00')
          })
          ended = date >= this.lastSlot(date)
        }
      } while (!ended)

      this.slotSlot = this.slotSlot && parseInt(this.slotSlot.replace(':', '')) >= parseInt(this.scheduleSlots[0].value.replace(':', '')) ? this.slotSlot : this.scheduleSlots[0].value
    },
    emitChange() {
      this.$nextTick(function () {
        this.scheduledDateDays()
        this.$emit('change', this.moment(this.slotDate + ' ' + this.slotSlot).local())
      })
    }
  }
}
</script>
